export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: -1
    },
    index2: {
      type: Number,
      default: -1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedValues: '',
      province: ['阿富汗', '新加坡', '安哥拉', '阿尔巴尼亚', '阿联酋', '阿根廷', '亚美尼亚', '法属南半球和南极领地', '澳大利亚', '奥地利', '阿塞拜疆', '布隆迪', '比利时', '贝宁', '布基纳法索', '孟加拉国', '保加利亚', '巴哈马', '波斯尼亚和黑塞哥维那', '白俄罗斯', '伯利兹', '百慕大', '玻利维亚', '巴西', '文莱', '不丹', '博茨瓦纳', '中非共和国', '加拿大', '瑞士', '智利', '中国', '象牙海岸', '喀麦隆', '刚果民主共和国', '刚果共和国', '哥伦比亚', '哥斯达黎加', '北塞浦路斯', '塞浦路斯', '捷克共和国', '德国', '吉布提', '丹麦', '多明尼加共和国', '阿尔及利亚', '厄瓜多尔', '埃及', '厄立特里亚', '西班牙', '爱沙尼亚', '埃塞俄比亚', '芬兰', '斐', '福克兰群岛', '法国', '加蓬', '英国', '格鲁吉亚', '加纳', '几内亚', '冈比亚', '几内亚比绍', '赤道几内亚', '希腊', '格陵兰', '危地马拉', '法属圭亚那', '圭亚那', '洪都拉斯', '克罗地亚', '海地', '匈牙利', '印尼', '印度', '爱尔兰', '伊朗', '伊拉克', '冰岛', '以色列', '意大利', '牙买加', '约旦', '日本', '哈萨克斯坦', '肯尼亚', '吉尔吉斯斯坦', '柬埔寨', '韩国', '科索沃', '科威特', '老挝', '黎巴嫩', '利比里亚', '利比亚', '斯里兰卡', '莱索托', '立陶宛', '卢森堡', '拉脱维亚', '摩洛哥', '摩尔多瓦', '马达加斯加', '墨西哥', '马其顿', '马里', '缅甸', '黑山', '蒙古', '莫桑比克', '毛里塔尼亚', '马拉维', '马来西亚', '纳米比亚', '新喀里多尼亚', '尼日尔', '尼日利亚', '尼加拉瓜', '荷兰', '挪威', '尼泊尔', '新西兰', '阿曼', '巴基斯坦', '巴拿马', '秘鲁', '菲律宾', '巴布亚新几内亚', '波兰', '波多黎各', '北朝鲜', '葡萄牙', '巴拉圭', '卡塔尔', '罗马尼亚', '俄罗斯', '卢旺达', '西撒哈拉', '沙特阿拉伯', '苏丹', '南苏丹', '塞内加尔', '所罗门群岛', '塞拉利昂', '萨尔瓦多', '索马里兰', '索马里', '塞尔维亚', '苏里南', '斯洛伐克', '斯洛文尼亚', '瑞典', '斯威士兰', '叙利亚', '乍得', '多哥', '泰国', '塔吉克斯坦', '土库曼斯坦', '东帝汶', '特里尼达和多巴哥', '突尼斯', '土耳其', '坦桑尼亚', '乌干达', '乌克兰', '乌拉圭', '美国', '乌兹别克斯坦', '委内瑞拉', '越南', '瓦努阿图', '西岸', '也门', '南非', '赞比亚', '津巴布韦']
    };
  },
  methods: {
    onChange() {
      this.$emit('change', this.selectedValues, this.index, this.index2);
    }
  }
};